export default __webpack_public_path__ + "static/media/united-states-of-america-svgrepo-com.c29455bd.svg";